/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param address
 * @param subaccountNumber
 * @param equity
 * @param freeCollateral
 * @param openPerpetualPositions
 * @param assetPositions
 * @param marginEnabled
 * @param updatedAtHeight
 * @param latestProcessedBlockHeight
 */
@JsExport
@Serializable
data class IndexerSubaccountResponseObject(

    val address: kotlin.String? = null,
    val subaccountNumber: kotlin.Int? = null,
    val equity: kotlin.String? = null,
    val freeCollateral: kotlin.String? = null,
    val openPerpetualPositions: Map<String, IndexerPerpetualPositionResponseObject>? = null,
    val assetPositions: Map<String, IndexerAssetPositionResponseObject>? = null,
    val marginEnabled: kotlin.Boolean? = null,
    val updatedAtHeight: kotlin.String? = null,
    val latestProcessedBlockHeight: kotlin.String? = null
)
